import { PostCreateSourceDataConfigurationByTrialCode, SourceDataConfigurationSingleResponse } from '@/api/dtos';
import { usePost } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<SourceDataConfigurationSingleResponse, SourceDataConfigurationSingleResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<SourceDataConfigurationSingleResponse, SourceDataConfigurationSingleResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useNewConfiguration = (trialCode?: string, copyId?: number, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return trialCode ? 
            () => new PostCreateSourceDataConfigurationByTrialCode({ trialCode, copyId }) : 
            undefined;
    }, [trialCode, copyId]);

    return usePost(request, { getData, getError}, configuration);
};

export default useNewConfiguration;